<template>
  <el-dialog
    title="编辑"
    v-model="isEdit"
    width="40%"
    center
    :close-on-click-modal="false"
    @closed="dialogClosedHandle"
  >
    <div class="page_warp">
      <div style="border: 1px solid #ccc">
        <Toolbar
          style="border-bottom: 1px solid #ccc"
          :editor="editorRef"
          :defaultConfig="toolbarConfig"
          :mode="mode"
        />
        <Editor
          style="height: 500px; overflow-y: hidden"
          v-model="valueHtml"
          :defaultConfig="editorConfig"
          :mode="mode"
          @onCreated="handleCreated"
        />
      </div>
      <div class="footer_btn_warp">
        <div class="cancle_btn" @click="closeModal()">取消</div>
        <div class="confirm_btn" @click="submit()">确定</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  defineComponent,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
  nextTick,
  shallowRef,
  onBeforeUnmount,
  ref,
} from "vue";
import "@wangeditor/editor/dist/css/style.css"; // 引入 css
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { imgFileToBase64, isPhone, isIdNo } from "@/libs/tools";
import { useStore } from "vuex";
import { apiObj } from "@/config/api";
export default defineComponent({
  name: "Edit",
  emits: ["getData"],
  components: { Editor, Toolbar },
  setup(props, context) {
    const store = useStore();
    const { proxy } = getCurrentInstance();
    // 编辑器实例，必须用 shallowRef
    const editorRef = shallowRef();
    // 内容 HTML
    const valueHtml = ref();
    const toolbarConfig = {};
    const editorConfig = { placeholder: "请输入内容..." };
    const getData = () => {
      context.emit("getData");
    };
    // 组件销毁时，也及时销毁编辑器
    onBeforeUnmount(() => {
      const editor = editorRef.value;
      if (editor == null) return;
      editor.destroy();
    });
    onMounted(() => {
      nextTick(() => {});
    });
    const data = reactive({
      isEdit: false,
      id: "",
    });
    const handleCreated = (editor) => {
      editorRef.value = editor; // 记录 editor 实例，重要！
    };
    //重置数据
    const init = (item) => {
      data.isEdit = true;
      valueHtml.value = item.agreeInfo;
      data.id = item.id;
    };

    const dialogClosedHandle = () => {
      data.isEdit = false;
    };
    const closeModal = () => {
      data.isEdit = false;
    };
    const submit = async () => {
      let params = {
        id: data.id,
        agreeInfo: editorRef.value.getHtml(),
        agreeInfoGrammar: editorRef.value.getText(),
      };
      const r = await proxy.$http.post(apiObj.agreementUpdate, params);
      if(r.code == 0 || r.respCode == "0000"){
        proxy.$message.success(r.respMsg);
        data.isEdit=false
        getData()
      }else{
        proxy.$message.error(r.msg || r.respMsg);
      }
    };

    return {
      ...toRefs(data),
      init,
      closeModal,
      getData,
      dialogClosedHandle,
      submit,
      editorRef,
      valueHtml,
      mode: "default", // 或 'simple'
      toolbarConfig,
      editorConfig,
      handleCreated,
    };
  },
});
</script>
<style scoped>
.page_warp {
  width: 100%;
}

.footer_btn_warp {
  width: 100%;
  height: 70px;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cancle_btn {
  width: 116px;
  height: 38px;
  background: #e36a19;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 38px;
  cursor: pointer;
  margin-right: 90px;
}
.confirm_btn {
  width: 116px;
  height: 38px;
  background: #293787;
  border-radius: 4px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 38px;
  cursor: pointer;
}
</style>
